import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Register from './pages/Register';
import ChanceLanding from './pages/ChanceLanding';
import Chance from './pages/Chance';
import Status from './pages/Status';

// Import brand logos
// CAMPAIGN 2 IS ATLAS ONLY -- Innovate is switched off for this run.
// Restore this import together with the brandLogo line below to bring it back.
// import innovateLogo from './img/innovate.png';
import atlasLogo from './img/atlas.png';

import sad from './img/sad.png';
import { checkWin } from './api/campaign';

function App() {
  const[isGameWin, setIsGameWin] = useState(false);
  const[giftType, setGiftType] = useState(null);
  const[countNum, setCountNum] = useState(false);
  const[userId, setUserId] = useState(false);
  // Get URL parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const b = queryParams.get("b");
  const t = queryParams.get("t");

//     React.useEffect(() => {
//   // Prevent double increment in React 18 Strict Mode
//   if (window.hasIncremented) return;
//   window.hasIncremented = true;

//   let count = parseInt(localStorage.getItem('myCounter')) || 0;
//   count += 1;
//   if (count > 10) count = 1;

//   localStorage.setItem('myCounter', count);
//   setCountNum(count);
//   console.log("Current count:", count);

//   // All games are lost - no wins
//   setIsGameWin(false);
// }, []);

  // Campaign 2 runs Atlas only, so default to 2 rather than Innovate.
  // Every QR for this campaign carries ?b=2 anyway.
  const brandId = b ? parseInt(b, 10) : 2;

  React.useEffect(() => {
    if (window.hasIncremented) return;
    window.hasIncremented = true;
    winCheck(t, brandId);
  }, []);

  // The quota proc decides win/lose and, on a win, which prize it is
  // (bag or voucher, alternating per shop per day).
  const winCheck = async (shopId, b) => {
    try {
      const { win, giftType } = await checkWin(shopId, b);
      setIsGameWin(win);
      setGiftType(giftType);
    } catch (error) {
      console.error("Error checking win:", error);
      setIsGameWin(false);
      setGiftType(null);
    }
  };
  
  const [currentPage, setCurrentPage] = useState(0); // 0: Landing, 1: Register, 2: ChanceLanding, 3: Scratch, 4: Status
  
  // Get brand logo based on b parameter
  // ATLAS ONLY for campaign 2. Original: brandId === 1 ? innovateLogo : atlasLogo
  const brandLogo = atlasLogo;
  
  // Chance Landing State
  const [selectedCards, setSelectedCards] = useState([]); // Array of selected card numbers [1, 5, 9]
  const [prizes, setPrizes] = useState([]); // Array of revealed brand logos
  const [currentCard, setCurrentCard] = useState(null); // Currently scratching card
  const [hasWon, setHasWon] = useState(false); // Overall win status

  // Handle navigation from Landing to Register
  const handleLandingNext = (page) => {
    setCurrentPage(page);
  };

  // Handle navigation from Register to ChanceLanding
  const handleRegisterNext = (page) => {
    setCurrentPage(2); // Go to ChanceLanding
  };

  // Handle card selection from ChanceLanding
  const handleCardSelection = (cardNumber) => {
    if (cardNumber === 'status') {
      // All 3 chances used, go to status
      setCurrentPage(4);
    } else {
      // User selected a card, go to scratch page
      setCurrentCard(cardNumber);
      setCurrentPage(3); // Go to Scratch page
    }
  };

  // Handle scratch completion and return to ChanceLanding
  const handleScratchComplete = () => {
    // Add revealed brand logo to prizes array
    const newPrize = {
      cardNumber: currentCard,
      image: brandLogo // Always the same brand logo
    };
    
    setPrizes([...prizes, newPrize]);
    
    // You can set win logic here if needed
    // For example: if all 3 scratches done, check if won
    if (prizes.length + 1 === 3) {
      // Optional: set win status based on some logic
      setHasWon(true);
    }
    
    // Return to ChanceLanding
    setCurrentPage(2);
    setCurrentCard(null);
  };

  // Get wording for current chance
  const getChanceWording = () => {
    const chance = selectedCards.length;
    const words = ["First", "Second", "Third"];
    return words[chance-1] || "First";
  };

  // Render current page
  const renderPage = () => {
    switch (currentPage) {
      case 0:
        // Landing Page
        return (
          <LandingPage 
            nextPage={handleLandingNext} 
            b={brandId} 
          />
        );
      
      case 1:
        // Registration Page
        return (
          <Register 
            nextPage={handleRegisterNext}
            b={brandId}
            shopId={t}
            setUserId={setUserId}
          />
        );
      
      case 2:
        // Chance Landing Page (9 cards grid)
        return (
          <ChanceLanding
            nextPage={handleCardSelection}
            selectedCards={selectedCards}
            setSelectedCards={setSelectedCards}
            prizes={prizes}
            currentChance={selectedCards.length}
            b={brandId}
          />
        );
      
      case 3:
        // Scratch Card Page - Always shows brand logo
        return (
          <Chance
            page={3}
            nextPage={handleScratchComplete}
            wording={getChanceWording()}
            img={isGameWin ? brandLogo : sad}
            b={brandId}
            setCurrentPage={setCurrentPage}
            selectedCards={selectedCards}
            setHasWon={isGameWin}
          />
        );
      
      case 4:
        // Status Page (Win/Lost)
        return (
          <Status
            state={isGameWin ? "win" : "lost"}
            b={brandId}
            userId={userId}
            giftType={giftType}
          />
        );
      
      default:
        return (
          <LandingPage 
            nextPage={handleLandingNext} 
            b={brandId} 
          />
        );
    }
  };

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;